import "../dsf_config";
//全局样式
import "../assets/styles/pc/dsfStyle.scss";
//注入本地元数据
import "../metadata";
//注入入本地api
import "../api";
//引入本项目所有pc组件
import pcComponent from "./../pc/components";
import App from "./App.vue";
import store from "../store";
import router from "./router";
import i18n from "../i18n";
import themesConfig from "_project/assets/styles/common";
import moment from "moment";

Vue.use(pcComponent);

dsf.init.initPlatform(Vue);
dsf.init.globalMixin(Vue);

Vue.config.productionTip = false;
Vue.prototype.$moment = moment;

// 登录页地址处理
let loginUrl = dsf.config.setting_public_pc_login_page;
router.beforeEach((to, from, next) => {
  //是否使用selenium等自动化工具打开网站--反爬
  if (dsf.config.antiScraping && window.navigator.webdriver) {
    location.replace(dsf.url.getWebPath("pc/error"));
  }
  // 非登录页，且需要登录，跳转到登录页面
  if ((to.meta.needLogin || to.fullPath == "/") && !dsf.getToken()) {
    let url = loginUrl + (to.fullPath !== "/" ? "?from=" + encodeURIComponent(location.href) : "");
    next(false);
    location.replace(url);
    return;
  }

  // 是否需要修改密码
  const alter_password = dsf.config.setting_public_alter_password_page;
  // 修改密码页面 登录页面 不需要跳转 可自己增加页面
  const arr = [alter_password, loginUrl];
  if (dsf.getToken() && dsf.cookies.get("reset_pwd") && !arr.some(item => item.includes(to.path))) {
    location.replace(alter_password + "?msg=" + dsf.cookies.get("reset_pwd"));
  }
  let lang = to.params.lang; // 获取动态路由参数 :lang 的值
  let languages = [undefined, "en"];
  //优先判断路由lang是否存在
  if (languages.includes(lang)) {
    // 匹配到支持的语言选项
    if (lang == "en") {
      i18n.locale = "en_US";
    } else {
      i18n.locale = "zh_CN";
    }
    //通过路由的title修改页面标题
    document.title = to.meta.title || "国家数据";
    if (i18n.locale != "zh_CN") {
      document.title = "National Data";
    }
    next();
  } else {
    // 不支持的语言选项，//强制匹配404页面
    next("*");
  }
});

new Vue({
  mixins: [dsf.$systemGlobalSetting(themesConfig)],
  store,
  router,
  i18n,
  data() {
    return {
      reload: false,
    };
  },
  created() {
    this.clickCount = 0;
    let _this = this;
    document.addEventListener("click", function (event) {
      _this.clickCount++;
      console.log("全局点击事件被触发", _this.clickCount);
    });

    setInterval(() => {
      if (_this.clickCount != 0) {
        this.$http.get("pblib/count/job/countVisitNum", { type: 1, num: _this.clickCount }).then(res => {
          _this.clickCount = 0;
        });
      }
    }, dsf.config.setting_visit_num_time || 600000);

    dsf.screenZoom.removeEvent();
    //监听window窗体变化后，递归组件执行组件的resize函数
    dsf.resizeDetector();
    //修复IE前进后退路由变化没效果的问题
    if ("-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style) {
      window.addEventListener(
        "hashchange",
        () => {
          var currentPath = window.location.hash.slice(1);
          if (router.path !== currentPath) {
            router.replace(currentPath);
          }
        },
        false,
      );
    }
    this.httpGet = dsf.http.get;
    this.httpPost = dsf.http.post;
    this.changeLanguages(i18n.locale);
  },
  computed: {
    _isEn() {
      return i18n.locale === "en_US";
    },
  },
  methods: {
    changeLanguages($$languages) {
      let _this = this;
      if ($$languages === "en_US") {
        dsf.http.get = function (...args) {
          let path = args[0];
          if (path.indexOf(":") == 0) {
            path = path.replace(":", "");
          } else {
            path = path.replace("/publicrelease/web/external", "/publicrelease/en/web/external").replace("/datascreen/relationweb", "/datascreen/en/relationweb");
          }
          args[0] = path;
          return _this.httpGet.apply(this, args);
        };
        dsf.http.post = function (...args) {
          let path = args[0];
          path = path.replace("/publicrelease/web/external", "/publicrelease/en/web/external").replace("/datascreen/relationweb", "/datascreen/en/relationweb");
          args[0] = path;
          return _this.httpPost.apply(this, args);
        };
        // if (this.$route.meta?.enTitle) {
        //   document.title = this.$route.meta.enTitle;
        // }
      } else {
        dsf.http.get = _this.httpGet;
        dsf.http.post = _this.httpPost;
        if (this.$route.meta?.title) {
          document.title = this.$route.meta.title;
        }
      }
      ELEMENT.locale(ELEMENT.lang[_this.$i18n.locale]);
      this.reload = true;
      this.$nextTick().then(() => {
        this.reload = false;
      });
    },
  },
  render: h => h(App),
}).$mount("#app");
